import React from "react"
import PayrollPeriodDateButtons from "./PayrollPeriodDateButtons"
import autobind from "class-autobind"
import * as payrollHelper from "../../helpers/payrollHelper"
import moment from "moment"
import { IDateRange, IDate } from "../../models"
import { red500 } from "material-ui/styles/colors"
interface IProps {
    referenceDate: IDate
    selectedPayGroupId: string
    handleChangeDate(referenceDate: IDate, payrollDates: IDateRange): void

    // Export TimecardDifference need to hide the Previous, Current period Buttons
    hidePrevNextPeriodButtons?: boolean
    errorStr?: string
}
interface IState {
    referenceDate: IDate
    payrollDates: IDateRange
}

export default class PayPeriodSelector extends React.Component<IProps, IState> {
    constructor(props: IProps) {
        super(props)
        this.state = {
            referenceDate: props.referenceDate,
            payrollDates: payrollHelper.getPayrollDates(props.referenceDate, props.selectedPayGroupId)
        }
        autobind(this)
    }

    componentWillReceiveProps(nextProps: IProps) {
        (this.props.selectedPayGroupId !== nextProps.selectedPayGroupId || !moment(this.props.referenceDate).isSame(nextProps.referenceDate)) &&
            this.setState({ referenceDate: nextProps.referenceDate, payrollDates: payrollHelper.getPayrollDates(nextProps.referenceDate, nextProps.selectedPayGroupId) })
    }

    handleChangeDate(referenceDate) {
        this.setState({
            referenceDate,
            payrollDates: payrollHelper.getPayrollDates(referenceDate, this.props.selectedPayGroupId)
        }, () =>
            this.props.handleChangeDate(this.state.referenceDate, this.state.payrollDates)
        )
    }

    render() {
        return (
            <div style={{ display: "flex", marginLeft: -15, padding: 20, position: "relative" }}>
                <div style={{ marginTop: this.props.hidePrevNextPeriodButtons ? 17 : 25 }}>
                    <i
                        data-intercom-target={"Payroll-Btn-PreviousPayroll"}
                        className="fa fa-arrow-circle-left"
                        title="View previous payroll"
                        onClick={() => this.handleChangeDate(moment(this.state.payrollDates.StartDate).add(-1, "day"))}
                        style={{ color: "#aaaaaa", cursor: "pointer" }}
                    />
                    <span style={{ fontSize: 15, marginLeft: 5, marginRight: 5 }}>
                        {moment(this.state.payrollDates.StartDate).format("ddd MMM. DD, YYYY")} &mdash; {moment(this.state.payrollDates.EndDate).format("ddd MMM. DD, YYYY")}
                    </span>
                    <i
                        data-intercom-target={"Payroll-Btn-NextPeriod"}
                        className="fa fa-arrow-circle-right"
                        title="View next period"
                        onClick={() => this.handleChangeDate(moment(this.state.payrollDates.EndDate).add(1, "day"))}
                        style={{ color: "#aaaaaa", cursor: "pointer" }}
                    />
                </div>
                <PayrollPeriodDateButtons
                    referenceDate={moment(this.state.referenceDate).toDate()}
                    handleChangeDate={this.handleChangeDate}
                    selectedPayGroupId={this.props.selectedPayGroupId}
                    hidePrevNextPeriodButtons={this.props.hidePrevNextPeriodButtons}
                />
                {this.props.errorStr &&
                    <div style={{ position: "absolute", bottom: 10, color: red500, fontSize: 12 }}>
                        {this.props.errorStr}
                    </div>
                }
            </div>
        )
    }
}
